import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';

import type { Entity } from './entities';

/**
 * triggers when the user clicks on a crm zone
 */
export interface CrmZoneClick {
  /**
   * the action the zone triggers when the user clicks on it
   */
  action: 'navigate' | 'login' | 'sign_up' | 'open_account' | 'open_crm_modal' | 'launch_game';
}

export const crmZoneClick = (data: CrmZoneClick, context?: Entity[]) =>
  trackSelfDescribingEvent({
    event: { schema: 'iglu:com.starsgroup/crm_zone_click/jsonschema/2-0-0', data },
    context
  });
